import { Link } from "react-router-dom";

export default function Cookies() {
  return (
    <div data-testid="cookies-page" className="py-20">
      <div className="container-max max-w-3xl">
        <div className="mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-3">Política de cookies</h1>
          <p className="text-slate-500 text-sm">Última actualización: 19 de enero de 2023</p>
        </div>

        <div className="prose-article">
          <h2>¿Qué son las cookies?</h2>
          <p>
            Cookie es un fichero que se descarga en su ordenador al acceder a determinadas páginas web.
            Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información
            sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información
            que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
            El navegador del usuario memoriza cookies en el disco duro solamente durante la sesión actual
            ocupando un espacio de memoria mínimo y no perjudicando al ordenador. Las cookies no contienen
            ninguna clase de información personal específica, y la mayoría de las mismas se borran del disco
            duro al finalizar la sesión de navegador (las denominadas cookies de sesión).
          </p>
          <p>
            La mayoría de los navegadores aceptan como estándar a las cookies y, con independencia de las mismas,
            permiten o impiden en los ajustes de seguridad las cookies temporales o memorizadas.
          </p>
          <p>
            Sin su expreso consentimiento –mediante la activación de las cookies en su navegador– este sitio web
            no enlazará en las cookies los datos memorizados con sus datos personales proporcionados en el momento
            del registro o la compra.
          </p>

          <h2>¿Qué tipos de cookies utilizamos en este sitio web?</h2>
          <p>
            Este sitio web utiliza cookies que permiten el funcionamiento y la prestación de los servicios
            ofrecidos en el mismo. Siguiendo las directrices de la Agencia Española de Protección de Datos
            procedemos a detallar el uso de cookies que hace esta web con el fin de informarle con la máxima
            exactitud posible.
          </p>
          <p>Este sitio web utiliza las siguientes cookies propias:</p>
          <p>
            <strong>Cookies técnicas:</strong> son aquellas que permiten al usuario la navegación a través de
            una página web, plataforma o aplicación y la utilización de las diferentes opciones o servicios que
            en ella existan, incluyendo aquellas que el editor utiliza para permitir la gestión y operativa de
            la página web y habilitar sus funciones y servicios, como, por ejemplo, controlar el tráfico y la
            comunicación de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los
            elementos que integran un pedido, realizar el proceso de compra de un pedido, gestionar el pago,
            controlar el fraude vinculado a la seguridad del servicio, realizar la solicitud de inscripción o
            participación en un evento, contar visitas a efectos de la facturación de licencias del software
            con el que funciona el servicio, utilizar elementos de seguridad durante la navegación, almacenar
            contenidos para la difusión de vídeos o sonido, habilitar contenidos dinámicos o compartir contenidos
            a través de redes sociales.
          </p>

          <h2>Desactivación o eliminación de cookies</h2>
          <p>
            Al desactivar cookies, algunos de los servicios disponibles podrían dejar de estar operativos.
            La forma de deshabilitar las cookies es diferente para cada navegador, pero normalmente puede hacerse
            desde el menú Herramientas u Opciones. También puede consultarse el menú de Ayuda del navegador donde
            puedes encontrar instrucciones. El usuario podrá en cualquier momento elegir qué cookies quiere que
            funcionen en este sitio web.
          </p>
          <p>
            Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración
            de las opciones del navegador:
          </p>
          <ul>
            <li><a className="text-teal-700 underline" href="http://windows.microsoft.com/es-es/windows-vista/Block-or-allow-cookies" target="_blank" rel="noopener noreferrer">Microsoft Internet Explorer / Edge</a></li>
            <li><a className="text-teal-700 underline" href="http://support.mozilla.org/es/kb/impedir-que-los-sitios-web-guarden-sus-preferencia" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a className="text-teal-700 underline" href="https://support.google.com/accounts/answer/61416?hl=es" target="_blank" rel="noopener noreferrer">Chrome</a></li>
            <li><a className="text-teal-700 underline" href="http://safari.helpmax.net/es/privacidad-y-seguridad/como-gestionar-las-cookies/" target="_blank" rel="noopener noreferrer">Safari</a></li>
            <li><a className="text-teal-700 underline" href="http://help.opera.com/Linux/10.60/es-ES/cookies.html" target="_blank" rel="noopener noreferrer">Opera</a></li>
            <li><a className="text-teal-700 underline" href="https://support.google.com/chrome/answer/2392971?hl=es" target="_blank" rel="noopener noreferrer">Chrome para Android</a></li>
          </ul>
          <p>También puede gestionar el almacén de cookies en su navegador a través de herramientas como:</p>
          <ul>
            <li><a className="text-teal-700 underline" href="https://www.ghostery.com" target="_blank" rel="noopener noreferrer">Ghostery</a></li>
            <li><a className="text-teal-700 underline" href="https://www.youronlinechoices.com/es/" target="_blank" rel="noopener noreferrer">Your online choices</a></li>
          </ul>
          <p>
            Más información relativa a la protección de sus datos personales en nuestra{" "}
            <Link to="/privacidad" className="text-teal-700 underline">Política de Privacidad</Link>.
          </p>
          <p>
            El editor se reserva el derecho de cambiar esta política de cookies si se realizan cambios en la
            configuración y/o uso de las mismas. Se publicará una versión actualizada en esta página web.
          </p>
        </div>
      </div>
    </div>
  );
}
